// src/components/StructureSelector.jsx
import React from 'react';
import { useStructure } from '../contexts/StructureContext';

const StructureSelector = () => {
  const { structures, currentStructure, changeStructure, loading } = useStructure();

  if (loading || !currentStructure) {
    return <div className="ml-4 text-white opacity-50">Chargement...</div>;
  }

  return (
    <div className="flex items-center ml-4">
      <select
        className="bg-primary-dark text-white border border-primary rounded px-2 py-1"
        value={currentStructure.id}
        onChange={(e) => {
          const selected = structures.find(s => s.id === e.target.value);
          if (selected) {
            changeStructure(selected);
          }
        }}
      >
        {structures.map(structure => (
          <option key={structure.id} value={structure.id}>
            {structure.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default StructureSelector;